import React from 'react';

// A specialized component to replace broken images with branded CSS illustrations
const VisualPanel = ({ type = "health", className = "" }) => {
  return (
    <div className={`relative overflow-hidden rounded-xl bg-[#0a0a0f] border border-white/5 min-h-[160px] flex items-center justify-center ${className}`}>
      {/* Background Grid */}
      <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, #444 1px, transparent 0)', backgroundSize: '24px 24px' }}></div>
      
      {type === "health" && (
        <div className="relative w-full h-full flex items-center justify-center">
          <div className="absolute w-32 h-32 bg-emerald-500/10 blur-3xl animate-pulse"></div>
          <svg viewBox="0 0 200 100" className="w-4/5 h-20 text-emerald-400 drop-shadow-[0_0_10px_rgba(16,185,129,0.4)]">
            <path d="M0,50 L30,50 L40,20 L55,80 L70,50 L100,50 L115,10 L135,90 L150,50 L200,50" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
          </svg>
        </div>
      )}

      {type === "retention" && (
        <div className="relative w-full h-full flex items-center justify-center">
          <div className="absolute w-32 h-32 bg-violet-500/10 blur-3xl"></div>
          <div className="flex gap-2 items-end h-24">
            {[40, 65, 55, 85, 75, 95].map((h, i) => (
              <div key={i} className="w-4 bg-violet-500/40 rounded-t-sm border-t border-violet-400/50" style={{ height: `${h}%` }}></div>
            ))}
          </div>
        </div>
      )}

      {type === "empty" && (
        <div className="text-center p-6">
          <div className="w-12 h-12 mx-auto mb-3 rounded-lg border border-white/10 bg-white/5 flex items-center justify-center">
            <div className="w-2 h-2 rounded-full bg-slate-600 animate-ping"></div>
          </div>
          <p className="text-xs text-slate-500 uppercase tracking-widest">Waiting for Signal...</p>
        </div>
      )}
    </div>
  );
};

export default VisualPanel;